import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { categoriasAPI } from "../services/api";
import { Categoria } from "../utils/types";

export function useCategorias(academiaId?: string) {
  return useQuery<Categoria[]>({
    queryKey: ["categorias", academiaId],
    queryFn: () => categoriasAPI.listar(academiaId).then((r) => r.data),
    enabled: true,
  });
}

export function useCategoria(id: string) {
  return useQuery<Categoria>({
    queryKey: ["categoria", id],
    queryFn: () => categoriasAPI.obtener(id).then((r) => r.data),
    enabled: !!id,
  });
}

export function useCategoriasJugadores(categoriaId: string) {
  return useQuery({
    queryKey: ["categoria-jugadores", categoriaId],
    queryFn: () => categoriasAPI.jugadores(categoriaId).then((r) => r.data),
    enabled: !!categoriaId,
  });
}

export function useCategoriaStaff(categoriaId: string) {
  return useQuery({
    queryKey: ["categoria-staff", categoriaId],
    queryFn: () => categoriasAPI.staff(categoriaId).then((r) => r.data),
    enabled: !!categoriaId,
  });
}

export function useCategoriaTorneos(categoriaId: string) {
  return useQuery({
    queryKey: ["categoria-torneos", categoriaId],
    queryFn: () => categoriasAPI.torneos(categoriaId).then((r) => r.data),
    enabled: !!categoriaId,
  });
}

export function useCrearCategoria() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<Categoria>) => categoriasAPI.crear(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["categorias"] }),
  });
}

export function useAsignarStaff() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: { staff_id: string; categoria_id: string; rol_en_categoria: string }) =>
      categoriasAPI.asignarStaff(data),
    onSuccess: (_data, vars) =>
      qc.invalidateQueries({ queryKey: ["categoria-staff", vars.categoria_id] }),
  });
}

/** Selector global de categoría — persiste en localStorage */
export function getCategoriaActiva(): string | null {
  return localStorage.getItem("selected_categoria_id");
}

export function setCategoriaActiva(id: string) {
  localStorage.setItem("selected_categoria_id", id);
}
